import * as React from 'react';
import { connect } from 'react-redux';
import Orders from '../../screens/Orders';

import {
  fetchChemistOrders,
  pageSelected,
  ChemistOrdersview,
  EditItemDetails,
  ordersInActive,
  fetchChemistInprogressOrders,
  fetchChemistCompletedOrders,
  fetchChemistCancelledOrders,
  InprogressOrderspageSelected,
  progresspageSelected,
  deliveredpageSelected,
  cancelledpageSelected,
  fetchDeliveryStatus,
  Totalitemretrieval,
  manualInvoice,
  ordersShippedActive,
  OrdersViewpageSelected,
  pdfOrderFullData,
  changePaymentstatus,
  fetchChemistitems,
  UrgentordersDelivered,
  createReturnOrder,
} from './action';
class OrdersContainer extends React.Component<Props, State> {
  render() {
    return (
      <Orders
        location={this.props.location}
        history={this.props.history}
        fetchChemistOrders={this.props.fetchChemistOrders}
        chemistOrderDetails={this.props.chemistOrderDetails}
        chemistOrdersCount={this.props.chemistOrdersCount}
        pageSelected={this.props.pageSelected}
        ChemistOrdersview={this.props.ChemistOrdersview}
        chemistOrderDtls={this.props.chemistOrderDtls}
        chemistOrderDtlsCount={this.props.chemistOrderDtlsCount}
        EditItemDetails={this.props.EditItemDetails}
        ordersInActive={this.props.ordersInActive}
        urgentOrderSearch={this.props.urgentOrderSearch}
        urgentOrderSearchSelectedPage={this.props.urgentOrderSearchSelectedPage}
        urgentorderSearchList={this.props.urgentorderSearchList}
        urgentorderSearchCount={this.props.urgentorderSearchCount}
        FliterSearchurgentOrder={this.props.FliterSearchurgentOrder}
        fltrurgentOrderPagetn={this.props.fltrurgentOrderPagetn}
        urgentorderFilterList={this.props.urgentorderFilterList}
        urgentorderFilterCount={this.props.urgentorderFilterCount}
        newOrdersListUrgent={this.props.newOrdersListUrgent}
        newOrdersListUrgentCount={this.props.newOrdersListUrgentCount}
        processedOrdersListUrgent={this.props.processedOrdersListUrgent}
        processedOrdersListUrgentCount={
          this.props.processedOrdersListUrgentCount
        }
        deliveredOrdersListUrgent={this.props.deliveredOrdersListUrgent}
        deliveredOrdersListUrgentCount={
          this.props.deliveredOrdersListUrgentCount
        }
        cancelledOrdersListUrgent={this.props.cancelledOrdersListUrgent}
        cancelledOrdersListUrgentCount={
          this.props.cancelledOrdersListUrgentCount
        }
        fetchChemistInprogressOrders={this.props.fetchChemistInprogressOrders}
        chemistinprogressOrderDetails={this.props.chemistinprogressOrderDetails}
        chemistinprogressOrderCount={this.props.chemistinprogressOrderCount}
        fetchChemistCompletedOrders={this.props.fetchChemistCompletedOrders}
        chemistcompleteOrderDetails={this.props.chemistcompleteOrderDetails}
        chemistcompleteOrderCount={this.props.chemistcompleteOrderCount}
        fetchChemistCancelledOrders={this.props.fetchChemistCancelledOrders}
        chemistcancelledOrderDetails={this.props.chemistcancelledOrderDetails}
        chemistcancelledOrderCount={this.props.chemistcancelledOrderCount}
        InprogressOrderspageSelected={this.props.InprogressOrderspageSelected}
        progresspageSelected={this.props.progresspageSelected}
        deliveredpageSelected={this.props.deliveredpageSelected}
        cancelledpageSelected={this.props.cancelledpageSelected}
        fetchDeliveryStatus={this.props.fetchDeliveryStatus}
        deliverystatusList={this.props.deliverystatusList}
        Totalitemretrieval={this.props.Totalitemretrieval}
        completeitemDetails={this.props.completeitemDetails}
        completeitemDetailsCount={this.props.completeitemDetailsCount}
        manualInvoice={this.props.manualInvoice}
        ordersShippedActive={this.props.ordersShippedActive}
        OrdersViewpageSelected={this.props.OrdersViewpageSelected}
        changePaymentstatus={this.props.changePaymentstatus}
        pdfOrderFullData={this.props.pdfOrderFullData}
        fetchChemistitems={this.props.fetchChemistitems}
        chemistOrderSearchList={this.props.chemistOrderSearchList}
        chemistOrderSearchCount={this.props.chemistOrderSearchCount}
        UrgentordersDelivered={this.props.UrgentordersDelivered}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchChemistOrders: value => {
      dispatch(fetchChemistOrders(value));
    },
    pageSelected: value => {
      dispatch(pageSelected(value));
    },
    ChemistOrdersview: value => {
      dispatch(ChemistOrdersview(value));
    },
    EditItemDetails: value => {
      // console.log("EditItemDetailsEditItemDetailsEditItemDetails");
      dispatch(EditItemDetails(value));
    },
    ordersInActive: value => {
      dispatch(ordersInActive(value));
    },
    fetchChemistInprogressOrders: value => {
      dispatch(fetchChemistInprogressOrders(value));
    },
    InprogressOrderspageSelected: value => {
      dispatch(InprogressOrderspageSelected(value));
    },
    fetchChemistCompletedOrders: value => {
      dispatch(fetchChemistCompletedOrders(value));
    },
    fetchChemistCancelledOrders: value => {
      dispatch(fetchChemistCancelledOrders(value));
    },
    progresspageSelected: value => {
      dispatch(progresspageSelected(value));
    },
    deliveredpageSelected: value => {
      dispatch(deliveredpageSelected(value));
    },
    cancelledpageSelected: value => {
      dispatch(cancelledpageSelected(value));
    },
    fetchDeliveryStatus: () => {
      dispatch(fetchDeliveryStatus());
    },
    Totalitemretrieval: value => {
      dispatch(Totalitemretrieval(value));
    },
    manualInvoice: value => {
      dispatch(manualInvoice(value));
    },
    ordersShippedActive: value => {
      dispatch(ordersShippedActive(value));
    },
    OrdersViewpageSelected: value => {
      dispatch(OrdersViewpageSelected(value));
    },
    changePaymentstatus: value => {
      dispatch(changePaymentstatus(value));
    },
    pdfOrderFullData: value => {
      dispatch(pdfOrderFullData(value));
    },
    fetchChemistitems: value => {
      console.log('#########1111111111111111', value);
      dispatch(fetchChemistitems(value));
    },
    UrgentordersDelivered: value => {
      dispatch(UrgentordersDelivered(value));
    },
    createReturnOrder: value => {
      dispatch(createReturnOrder(value));
    },
  };
}
const mapStateToProps = state => {
  return {
    chemistOrderDetails: state.OrdersReducer.chemistOrderDetails,
    chemistOrdersCount: state.OrdersReducer.chemistOrdersCount,
    chemistOrderDtls: state.OrdersReducer.chemistOrderDtls,
    chemistOrderDtlsCount: state.OrdersReducer.chemistOrderDtlsCount,

    newOrdersListUrgent: state.OrdersReducer.newOrdersListUrgent,
    newOrdersListUrgentCount: state.OrdersReducer.newOrdersListUrgentCount,
    processedOrdersListUrgent: state.OrdersReducer.processedOrdersListUrgent,
    processedOrdersListUrgentCount:
      state.OrdersReducer.processedOrdersListUrgentCount,
    deliveredOrdersListUrgent: state.OrdersReducer.deliveredOrdersListUrgent,
    deliveredOrdersListUrgentCount:
      state.OrdersReducer.deliveredOrdersListUrgentCount,
    cancelledOrdersListUrgent: state.OrdersReducer.cancelledOrdersListUrgent,
    cancelledOrdersListUrgentCount:
      state.OrdersReducer.cancelledOrdersListUrgentCount,
    chemistinprogressOrderDetails:
      state.OrdersReducer.chemistinprogressOrderDetails,
    chemistinprogressOrderCount:
      state.OrdersReducer.chemistinprogressOrderCount,

    chemistcompleteOrderDetails:
      state.OrdersReducer.chemistcompleteOrderDetails,
    chemistcompleteOrderCount: state.OrdersReducer.chemistcompleteOrderCount,

    chemistcancelledOrderDetails:
      state.OrdersReducer.chemistcancelledOrderDetails,
    chemistcancelledOrderCount: state.OrdersReducer.chemistcancelledOrderCount,
    deliverystatusList: state.OrdersReducer.deliverystatusList,

    completeitemDetails: state.NormalOrderReducer.completeitemDetails,
    completeitemDetailsCount: state.NormalOrderReducer.completeitemDetailsCount,

    chemistOrderSearchList: state.OrdersReducer.chemistOrderSearchList,
    chemistOrderSearchCount: state.OrdersReducer.chemistOrderSearchCount,
  };
};

export default connect(mapStateToProps, bindAction)(OrdersContainer);
